<template>
  <input
    ref="inputRef"
    v-model="displayValue"
    type="tel"
    :placeholder="placeholder"
    :disabled="disabled"
    class="form-control"
    @input="handleInput"
    @keydown="handleKeydown"
    @paste="handlePaste"
    @blur="handleBlur"
    @focus="handleFocus"
  />
</template>

<script>
export default {
  name: 'PhoneNumberInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '(555) 555-5555'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: '',
      isFocused: false
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue) {
        if (!this.isFocused) {
          this.displayValue = this.formatPhoneNumber(newValue || '');
        }
      }
    }
  },
  methods: {
    handleInput(event) {
      const input = event.target.value;
      const cleaned = this.cleanPhoneNumber(input);
      const formatted = this.formatPhoneNumber(cleaned);

      this.displayValue = formatted;
      this.$emit('update:modelValue', cleaned);
    },
    handleKeydown(event) {
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 13, 27, 46].indexOf(event.keyCode) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X (and Cmd on Mac)
        (event.keyCode === 65 && (event.ctrlKey === true || event.metaKey === true)) ||
        (event.keyCode === 67 && (event.ctrlKey === true || event.metaKey === true)) ||
        (event.keyCode === 86 && (event.ctrlKey === true || event.metaKey === true)) ||
        (event.keyCode === 88 && (event.ctrlKey === true || event.metaKey === true)) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
        return;
      }

      // Ensure that it is a number and stop the keypress
      if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const cleaned = this.cleanPhoneNumber(pastedText);
      const formatted = this.formatPhoneNumber(cleaned);

      this.displayValue = formatted;
      this.$emit('update:modelValue', cleaned);
    },
    handleFocus(event) {
      this.isFocused = true;
      // Auto-select all text for easy overwriting
      event.target.select();
    },
    handleBlur() {
      this.isFocused = false;
      // Re-format on blur to ensure consistency
      const cleaned = this.cleanPhoneNumber(this.displayValue);
      this.displayValue = this.formatPhoneNumber(cleaned);
    },
    cleanPhoneNumber(value) {
      // Remove all non-numeric characters
      return (value || '').replace(/\D/g, '');
    },
    formatPhoneNumber(value) {
      if (!value) return '';

      const cleaned = this.cleanPhoneNumber(value);

      // Format: (XXX) XXX-XXXX
      if (cleaned.length === 0) return '';
      if (cleaned.length <= 3) return `(${cleaned}`;
      if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
/* Inherits .form-control styles from global.css */
</style>
